import cleanApp from './cleanApp'
import timeReload from './timeReload'

const internalReset = (reset?: () => void) => {
  cleanApp(reset)
  timeReload()
}

export default internalReset
